export default __webpack_public_path__ + "static/BCSProjectList-ed67de3ce1e34fc7c679eefa3dd35624.pdf";